export default __webpack_public_path__ + "b53d2e1c6ccc1beb7cd2f12ee91e7b43.png";